// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bordered[data-v-6118f350]{border-right:1px solid}.sticky[data-v-6118f350]{position:-webkit-sticky;position:sticky;top:84px;height:calc(100vh - 84px);margin-right:2.5rem;overflow-y:auto;flex-shrink:0}.o-side[data-v-6118f350]{position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
